import React, { Component } from "react";
import { Card, Modal } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import Offer from "../assets/Offer.png";
import KinderHands from "../assets/KinderHands.png";
import FlowerBackground from "../assets/FlowerBackground.jpeg";
import KinderVertical from "../assets/KinderVertical.jpeg";
import EmailSignupConsumer from "../components/EmailSignupConsumer";
import { Apple, Android, Language, SportsRugby } from "@material-ui/icons";
import circles from "../assets/circles.png";
import people from "../assets/people.png";
import missed_chances from "../assets/missed_chances.png";
import atpark from "../assets/atpark.png";
import { slideInLeft, slideInRight } from "react-animations";

import "./Home.css";
import KinderWhite from "../assets/KinderWhite.png";
import ScrollAnimation from "react-animate-on-scroll";
import InstagramEmbed from "react-instagram-embed";
import FeaturedBy from "../components/FeaturedBy";
var Scroll = require("react-scroll");
var _ = require("lodash");

var ReactRotatingText = require("react-rotating-text");

var Link = Scroll.Link;
var Element = Scroll.Element;
let scroll = Scroll.animateScroll;

const uses = [
  "share garden produce",
  "find conversation partners",
  "make music together",
  "find long-term parking spots",
  "give away unneeded gifts",
  "find jobs",
  "pick up last-minute groceries"
];

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollY: 0,
      modalOpen: false
    };
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.checkHeader);
  };

  checkHeader = _.throttle(() => {
    this.setState({ scrollY: Math.round(window.scrollY) });
  }, 300);

  scrollToTop() {
    scroll.scrollToTop();
  }

  render() {
    if (this.state.scrollY > 75) {
      var transformValue = "scaleY(1)";
    } else {
      var transformValue = "scaleY(0)";
    }
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          fontFamily: "Quicksand"
        }}
      >
        <div
          className="row-above-fold"
          style={
            window.innerWidth >= 1200
              ? {
                  background: `linear-gradient(rgba(245,181,69, 0.8),rgba(119,120,123, 0.8)),url(${FlowerBackground}) no-repeat`,
                  backgroundSize: "100vw 100vh",
                  width: "120vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  textAlign: "center",
                  overflow: "hidden",
                  flexWrap: "wrap"
                }
              : {
                  background: `linear-gradient(rgba(245,181,69, 0.8),rgba(119,120,123, 0.8)),url(${FlowerBackground}) no-repeat`,
                  // background: `linear-gradient(rgba(28,107,247, 0.6),rgba(28,107,247, 0.6)),url(${KinderVertical}) no-repeat`,
                  backgroundSize: "cover",
                  width: "100vw",
                  height: "125vh",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  textAlign: "center",
                  flexWrap: "wrap"
                }
          }
        >
          {window.innerWidth >= 1200 && (
            <div
              className="row"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                height: "8%",
                paddingLeft: "6%",
                alignItems: "center",
                justifyContent: "space-between",
                overflow: "hidden",
                position: "fixed",
                top: 0,
                backgroundColor: "#77787b",
                zIndex: 100000,
                transition: "transform 0.3s ease-out", // note that we're transitioning transform, not height!
                transform: transformValue
              }}
            >
              <div
                style={{
                  width: "90%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to="about"
                    smooth={true}
                    offset={0}
                    duration={500}
                    style={{
                      marginRight: "20%",
                      color: "white",
                      fontSize: 26,
                      cursor: "pointer",
                      fontWeight: "600"
                    }}
                  >
                    About
                  </Link>
                </div>
                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to="who"
                    smooth={true}
                    offset={0}
                    duration={500}
                    style={{
                      color: "white",
                      fontSize: 26,
                      cursor: "pointer",
                      fontWeight: "600"
                    }}
                  >
                    Mission
                  </Link>
                </div>
                <div
                  className="col"
                  style={{
                    width: "20%",
                    alignSelf: "center",
                    marginTop: "0.5%"
                  }}
                  onClick={this.scrollToTop}
                >
                  <img
                    src={KinderWhite}
                    alt="Kinder Logo"
                    style={{ width: "160px", cursor: "pointer" }}
                  />
                </div>

                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to="instagram"
                    smooth={true}
                    offset={0}
                    duration={500}
                    style={{
                      color: "white",
                      fontSize: 26,
                      cursor: "pointer",
                      marginLeft: "5%",
                      marginRight: "5%",
                      fontWeight: "600",
                      verticalAlign: "center"
                    }}
                  >
                    KW Project
                  </Link>
                </div>
                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <a
                    href="https://kinder-us.com"
                    className="signin-button"
                    style={{}}
                  >
                    <p style={{ marginTop: "10px" }}>Sign in</p>
                  </a>
                </div>
              </div>
            </div>
          )}

          {window.innerWidth >= 1200 && (
            <div
              className="row"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                height: "8%",
                alignItems: "center",
                overflow: "hidden",
                top: 10,
                zIndex: 100000,
                paddingLeft: "1%"
              }}
            >
              <div
                style={{
                  width: "94%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to="about"
                    smooth={true}
                    offset={0}
                    duration={500}
                    style={{
                      color: "white",
                      fontSize: 26,
                      cursor: "pointer",
                      fontWeight: "600"
                    }}
                  >
                    About
                  </Link>
                </div>
                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to="who"
                    smooth={true}
                    offset={0}
                    duration={500}
                    style={{
                      color: "white",
                      fontSize: 26,
                      cursor: "pointer",
                      fontWeight: "600"
                    }}
                  >
                    Mission
                  </Link>
                </div>
                <div
                  className="col"
                  style={{
                    width: "20%",
                    alignSelf: "center",
                    marginTop: "0.5%"
                  }}
                  onClick={this.scrollToTop}
                >
                  <img
                    src={KinderWhite}
                    alt="Kinder Logo"
                    style={{ width: "160px" }}
                  />
                </div>

                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to="instagram"
                    smooth={true}
                    offset={0}
                    duration={500}
                    style={{
                      color: "white",
                      fontSize: 26,
                      cursor: "pointer",
                      marginLeft: "5%",
                      marginRight: "5%",
                      fontWeight: "600",
                      verticalAlign: "center"
                    }}
                  >
                    KW Project
                  </Link>
                </div>
                <div
                  className="col"
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <a href="https://kinder-us.com" className="signin-button">
                    <p style={{ marginTop: "10px" }}>Sign in</p>
                  </a>
                </div>
              </div>
            </div>
          )}

          <div
            className="col"
            style={
              window.innerWidth >= 1200
                ? {
                    width: "100%",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    alignSelf: "center",
                    flexWrap: "wrap",
                    marginTop: "15%",
                    marginBottom: "5%",
                    marginLeft: "5%"
                  }
                : {
                    width: "100%",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    alignSelf: "center",
                    flexWrap: "wrap"
                  }
            }
          >
            <div
              style={
                window.innerWidth >= 1200
                  ? {}
                  : {
                      height: window.innerHeight,
                      width: window.innerWidth
                    }
              }
            >
              <p
                style={
                  window.innerWidth >= 1200
                    ? {
                        fontSize: 45,
                        fontWeight: "700",
                        color: "#ffffff",
                        width: "65%",
                        marginLeft: "3%"
                      }
                    : {
                        height: "35%",
                        maxWidth: "80%",
                        fontWeight: "700",
                        fontSize: 30,
                        color: "#ffffff",
                        marginLeft: "5%"
                      }
                }
              >
                Communities in Los Angeles are using Kinder to <br />
                <ReactRotatingText
                  items={uses}
                  typingInterval={25}
                  deletingInterval={25}
                  pause={2500}
                />
                {/* Building community, together */}
                {/* Make it a beautiful day in your neighborhood */}
                {/* Kinder is a support network for your community */}
              </p>
              <p
                style={{
                  fontSize: 24,
                  fontWeight: "700",
                  color: "#ffffff",
                  maxWidth: window.innerWidth >= 1200 ? "45%" : "80%",
                  marginLeft: window.innerWidth >= 1200 ? "3%" : "5%"
                }}
              >
                Talking to your neighbors is just the start
              </p>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginLeft: window.innerWidth >= 1200 ? "3%" : "5%",
                  marginTop: "2%",
                  flexWrap: "wrap",
                  maxWidth: "100%"
                }}
              >
                <a
                  href="https://apps.apple.com/app/apple-store/id1479425814?pt=120437330&ct=landing-page&mt=8"
                  style={{
                    textDecoration: "none",
                    justifyContent: "center",
                    marginBottom: window.innerWidth < 1200 ? "2%" : "0%"
                  }}
                  target="_blank"
                  className="signup-button-1"
                >
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: "700",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Apple style={{ paddingRight: "5px" }} />
                    {window.innerWidth < 1200
                      ? "App Store"
                      : "Download on the App Store"}
                  </p>
                </a>
                {window.innerWidth >= 1200 && (
                  <div style={{ height: "100%", width: "5%" }} />
                )}

                <a
                  href="https://play.google.com/store/apps/details?id=com.kinder.testing"
                  style={{
                    textDecoration: "none",
                    justifyContent: "center",
                    marginBottom: window.innerWidth < 1200 ? "2%" : "0%"
                  }}
                  target="_blank"
                  className="signup-button-2"
                >
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: "700",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Android style={{ paddingRight: "5px" }} />
                    {window.innerWidth < 1200
                      ? "Google Play"
                      : "Download on Google Play"}
                  </p>
                </a>
                {window.innerWidth >= 1200 && (
                  <div style={{ height: "100%", width: "5%" }} />
                )}
                <a
                  href="https://kinder-us.com"
                  style={{
                    textDecoration: "none",
                    justifyContent: "center"
                  }}
                  target="_blank"
                  className="signup-button-3"
                >
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: "700",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Language style={{ paddingRight: "5px" }} />
                    {window.innerWidth < 1200 ? "Web" : "Go to the website"}
                  </p>
                </a>
              </div>
              {window.innerWidth < 1200 && (
                <div style={{ height: "2%", width: "100%" }} />
              )}
              <div
                style={{
                  maxWidth: "85%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  marginTop: window.innerWidth >= 1200 ? "2%" : "0%",
                  marginLeft: window.innerWidth >= 1200 ? "3%" : "5%"
                }}
              >
                {/* <p
                  style={{
                    fontSize: 26,
                    fontWeight: "700",
                    fontFamily: "Quicksand",
                    color:"#FFFFFF",
                    verticalAlign:"center"
                  }}
                >
                  
                </p> */}
                <a
                  target="_blank"
                  href="https://hunterhillman.typeform.com/to/tbrxGS"
                  style={{
                    color: "#FFFFFF",
                    fontSize: 26,
                    fontWeight: "700",
                    fontFamily: "Quicksand",
                    width: "100%"
                  }}
                >
                  Not in LA? Add your community to the waitlist!
                </a>
              </div>
            </div>
          </div>
        </div>
        <FeaturedBy />
        <Element name="about" style={{ alignSelf: "flex-start" }} />

        <Element name="how" style={{ alignSelf: "flex-start" }} />
        <div
          className="row"
          style={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            marginTop: "5%"
          }}
        >
          <ScrollAnimation
            animateIn="slideInLeft"
            duration={1}
            // animateOut="slideOutRight"
            className="row"
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "center",
              flexWrap: "wrap"
            }}
          >
            <img
              src={circles}
              alt="Kinder app offer screen"
              style={
                window.innerWidth >= 1200
                  ? { width: "300px", order: 1 }
                  : { width: "300px", height: "260px", order: 1 }
              }
            />

            <div
              style={
                window.innerWidth >= 1200
                  ? { width: "40%", marginLeft: "2%" }
                  : { width: "90%", order: 2 }
              }
            >
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 34,
                  fontWeight: "700",
                  color: "#77787b"
                }}
              >
                What is Kinder?
              </p>
              <div
                style={{
                  width: "80%",
                  height: "5px",
                  borderRadius: "20px",
                  backgroundColor: "#f5b545"
                }}
              />
              <p
                style={
                  window.innerWidth >= 1200
                    ? {
                        fontWeight: 500,
                        fontSize: 22,
                        fontWeight: "700",
                        color: "#77787b"
                      }
                    : {
                        fontWeight: 500,
                        fontSize: 18,
                        color: "#77787b"
                      }
                }
              >
                People helping people. A support network you never knew you had.
              </p>
            </div>
          </ScrollAnimation>
          <ScrollAnimation
            animateIn="slideInRight"
            duration={1}
            // animateOut="slideOutRight"
            className="row"
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: "5%",
              flexWrap: "wrap"
            }}
          >
            <div
              style={
                window.innerWidth >= 1200
                  ? { width: "40%", order: 2 }
                  : { width: "90%", order: 2 }
              }
            >
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 34,
                  fontWeight: "700",
                  color: "#77787b"
                }}
              >
                How can I use Kinder?
              </p>
              <div
                style={{
                  width: "80%",
                  height: "5px",
                  borderRadius: "20px",
                  backgroundColor: "#fa3d6e"
                }}
              />
              <p
                style={
                  window.innerWidth >= 1200
                    ? {
                        fontWeight: 500,
                        fontSize: 22,
                        fontWeight: "700",
                        color: "#77787b",
                        flexWrap: "wrap"
                      }
                    : {
                        fontWeight: 500,
                        fontSize: 18,
                        color: "#77787b",
                        flexWrap: "wrap"
                      }
                }
              >
                Borrow a stapler. Share some tomatoes from your garden.
                Recommend a restaurant. The limit is your imagination!
              </p>
            </div>{" "}
            <img
              src={atpark}
              alt="Kinder app offer screen"
              style={
                window.innerWidth >= 1200
                  ? { width: "300px", order: 1 }
                  : { width: "300px", height: "260px", order: 1 }
              }
            />
          </ScrollAnimation>
          <ScrollAnimation
            animateIn="slideInLeft"
            duration={1}
            // animateOut="slideOutRight"
            className="row"
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: "5%",
              flexWrap: "wrap"
            }}
          >
            <img
              src={missed_chances}
              alt="Kinder app offer screen"
              style={
                window.innerWidth >= 1200
                  ? { width: "300px", order: 1 }
                  : { width: "300px", height: "260px", order: 1 }
              }
            />
            <div
              style={
                window.innerWidth >= 1200
                  ? { width: "40%", marginLeft: "2%" }
                  : { width: "90%", order: 2 }
              }
            >
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 34,
                  fontWeight: "700",
                  color: "#77787b"
                }}
              >
                When is Kinder coming to my community?
              </p>
              <div
                style={{
                  width: "80%",
                  height: "5px",
                  borderRadius: "20px",
                  backgroundColor: "#1c6bf7"
                }}
              />
              <p
                style={
                  window.innerWidth >= 1200
                    ? {
                        fontWeight: 500,
                        fontSize: 20,
                        fontWeight: "700",
                        color: "#77787b"
                      }
                    : {
                        fontWeight: 500,
                        fontSize: 18,
                        color: "#77787b"
                      }
                }
              >
                Soon! We're pacing our rollout to make sure every community gets
                the attention and care it deserves. If you think Kinder could
                help out your community, add your name to the waitlist above and
                we'll be in touch.
              </p>
            </div>
          </ScrollAnimation>
        </div>
        <div
          style={{
            display:"flex",
            width: "100%",
            justifyContent: "center",
            alignItems:"center",
            marginTop: "5%",
            backgroundColor: "rgba(209,211,212, 0.2)"
          }}
        >
          <ScrollAnimation
            animateIn="fadeIn"
            duration={1}
            className="row"
            style={
              window.innerWidth >= 1200
                ? {
                    display: "flex",
                    padding: "2% 0% 2% 0%",
                    width: "88%",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap"
                  }
                : {
                    display: "flex",
                    padding: "2% 0% 2% 0%",
                    width: "95%",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap"
                  }
            }
          >
            <Element name="instagram" style={{ alignSelf: "flex-start" }} />

            <ScrollAnimation
              animateIn="slideInLeft"
              duration={1}
              className="col"
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >
              <p
                style={{
                  fontSize: 40,
                  fontWeight: "700",
                  color: "#f5b545",
                  width: "80%",
                  textAlign: "left"
                }}
              >
                The Kinder World Project
              </p>
              <p
                style={{
                  fontSize: 24,
                  fontWeight: "600",
                  color: "#77787b",
                  width: "80%",
                  textAlign: "left",
                  marginTop: "-1%",
                  marginBottom: "5%"
                }}
              >
                Each month, we make donations to organizations doing great work
                in the communities that we serve. By using KinderUS, you're
                helping your community earn real-life rewards that make your
                neighborhood a more wonderful place to live.
                <br />
                <br />
                While building KinderUS, we've also found that the world is full
                of kind people with untold stories. As part of the Kinder World
                Project, we hope to tell some of them.
              </p>
            </ScrollAnimation>
            <ScrollAnimation
              animateIn="bounceInRight"
              duration={1}
              className="col"
              style={
                window.innerWidth > 1200
                  ? {
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                      width: "90%",
                      flexDirection: "row",
                      flexWrap: "wrap"
                    }
                  : {
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row"
                    }
              }
            >
              <InstagramEmbed
                url="https://www.instagram.com/p/B_f6ZGnAYVe/"
                maxWidth={320}
                hideCaption={true}
                containerTagName="div"
                protocol=""
                injectScript
                onLoading={() => {}}
                onSuccess={() => {}}
                onAfterRender={() => {}}
                onFailure={() => {}}
              />
              <InstagramEmbed
                url="https://www.instagram.com/p/B9rnFYCgfP0/"
                maxWidth={320}
                hideCaption={true}
                containerTagName="div"
                protocol=""
                injectScript
                onLoading={() => {}}
                onSuccess={() => {}}
                onAfterRender={() => {}}
                onFailure={() => {}}
              />
              <InstagramEmbed
                url="https://www.instagram.com/p/B552DAwJA34/"
                maxWidth={320}
                hideCaption={true}
                containerTagName="div"
                protocol=""
                injectScript
                onLoading={() => {}}
                onSuccess={() => {}}
                onAfterRender={() => {}}
                onFailure={() => {}}
              />
            </ScrollAnimation>
          </ScrollAnimation>
        </div>
        <ScrollAnimation
          animateIn="fadeIn"
          duration={1}
          className="row"
          style={
            window.innerWidth >= 1200
              ? {
                  alignSelf: "center",
                  display: "flex",
                  padding: "2% 0% 2% 0%",
                  width: "88%",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#ffffff"
                }
              : {
                  display: "flex",
                  padding: "2% 0% 2% 0%",
                  width: "95%",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#ffffff",
                  flexWrap: "wrap"
                }
          }
        >
          <Element name="who" style={{ alignSelf: "flex-start" }} />

          <ScrollAnimation
            animateIn="slideInRight"
            duration={1}
            className="col"
            style={
              window.innerWidth > 1200
                ? {
                    justifyContent: "center",
                    alignItems: "center",
                    width: "80%"
                  }
                : {
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "5%"
                  }
            }
          >
            <ScrollAnimation
              animateIn="slideInLeft"
              duration={1}
              className="col"
              style={{ alignItems: "flex-start" }}
            >
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 50,
                  fontWeight: "700",
                  color: "#77787b",
                  marginLeft: window.innerWidth >= 1200 ? "0%" : "0%"
                }}
              >
                Our Story
              </p>
            </ScrollAnimation>
            <p
              style={
                window.innerWidth > 1200
                  ? {
                      color: "#77787b",
                      fontWeight: 400,
                      fontSize: 26,
                      textAlign: "left"
                    }
                  : {
                      color: "#77787b",
                      fontWeight: 400,
                      fontSize: 18,
                      textAlign: "left"
                    }
              }
            >
              Our founders, Hunter and Spencer Hillman, are brothers who believe
              that there's a better way to build and sustain meaningful
              communities.
              <br />
              <br />
              We've spoken to thousands of working people, volunteers, and
              experts around the country, and those conversations led us to a
              simple, age-old idea: it takes a village.
              <br />
              <br />
              Our goal is to build authentic local communities around in-person
              relationships. We have more in common than we realize, and
              building a better society starts with the people around us.
              <br />
              <br />
              We invite you to help us build a Kinder World.
            </p>
          </ScrollAnimation>
        </ScrollAnimation>
        <div
          className="row"
          style={{
            display: "flex",
            padding: "2% 2% 2% 2%",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#414141"
          }}
        >
          <div className="col" style={{ width: "90%", flexWrap: "wrap" }}>
            <a
              href="https://twitter.com/kindertogether"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Twitter
            </a>

            <a
              href="https://www.instagram.com/kindertogether/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Instagram
            </a>

            <a
              href="mailto:post@kindertogether.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Jobs
            </a>
            <a
              href="mailto:post@kindertogether.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Contact Us
            </a>
            <RouterLink
              to="/privacy"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Privacy
            </RouterLink>
            <RouterLink
              to="/terms"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Terms
            </RouterLink>

            <RouterLink
              to="/prohibited-use"
              style={{
                color: "white",
                fontSize: 18,
                padding: "0% 2% 0% 0%",
                textDecoration: "none"
              }}
            >
              {" "}
              Prohibited Use
            </RouterLink>

            <p style={{ color: "white", fontSize: 24, padding: "0% 2% 0% 0%" }}>
              {" "}
              © 2020 Kinder World, PBC
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;

// <Card
// style={{
//   maxWidth: "300px",
//   maxHeight: "560px",
//   textAlign: "center",
//   alignSelf:"center",
//   justifyContent: "center",
//   color: "#5C626C",
//   padding: "8% 8% 8% 8%",
//   borderRadius: "10px"
// }}
// >
// <object
//   data={Kinder}
//   type="image/svg+xml"
//   style={{ marginLeft: "43px", width: "250px", zIndex: 100000 }}
// >
//   <img
//     src={KinderGray}
//     alt="Kinder logo"
//     style={{ width: "140px", zIndex: 100000 }}
//   />
// </object>
// <p style={{ fontSize: "20px", fontWeight: "400" }}>
//   It takes a village. <br /> Sign up to build yours.
// </p>
// {/* <div>
// <p style={{ fontSize: "18px", textAlign: "left", fontStyle: "italic" }}>
//   Get help with household tasks
//   <br />
//   Give time to help a neighbor
//   <br />

//   Get a deal from a local business.
// </p>
// </div> */}
// <div>
//   <EmailSignupConsumer />
// </div>
// <img
//   src={ComingSoon}
//   alt="Kinder will be available soon on the App Store and Google Play"
//   style={{ margin: "10%", width: "140px" }}
// />
// </Card>
